
/* ═══════════════════════════════════════
   RC WISHLIST — localStorage
   Cœur sur chaque produit + page dédiée
═══════════════════════════════════════ */
const RCWishlist = {
  KEY: 'rc_wishlist',

  get() {
    try { return JSON.parse(localStorage.getItem(this.KEY)) || []; }
    catch { return []; }
  },

  save(items) {
    localStorage.setItem(this.KEY, JSON.stringify(items));
    this.updateCounters();
    document.dispatchEvent(new CustomEvent('rc:wishlist:updated', { detail: items }));
  },

  has(id) { return this.get().some(p => p.id == id); },

  toggle(product) {
    let items = this.get();
    const idx = items.findIndex(p => p.id == product.id);
    if (idx > -1) items.splice(idx, 1);
    else items.unshift(product);
    this.save(items);
    return idx === -1;
  },

  updateCounters() {
    const count = this.get().length;
    document.querySelectorAll('.rc-wishlist-count').forEach(el => {
      if (el.closest('.rc-wishlist-header-link')) {
        // Badge header : classe --visible uniquement si count > 0
        el.classList.remove('visually-hidden');
        if (count > 0) {
          el.textContent = count;
          el.classList.add('rc-badge--visible');
        } else {
          el.textContent = '';
          el.classList.remove('rc-badge--visible');
        }
      } else {
        el.textContent = count > 0 ? `(${count})` : '';
        el.style.display = count > 0 ? 'inline' : 'none';
      }
    });
  },

  renderButton(productId, productData) {
    const btn = document.createElement('button');
    btn.className = 'rc-heart-btn';
    btn.dataset.productId = productId;
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.innerHTML = this.has(productId) ? RCWishlist.HEART_FILLED : RCWishlist.HEART_EMPTY;
    btn.classList.toggle('rc-heart-btn--active', this.has(productId));

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const added = this.toggle(productData);
      btn.innerHTML = added ? RCWishlist.HEART_FILLED : RCWishlist.HEART_EMPTY;
      btn.classList.toggle('rc-heart-btn--active', added);
      // Feedback visuel
      btn.style.transform = 'scale(1.3)';
      setTimeout(() => btn.style.transform = '', 200);
    });
    return btn;
  },

  HEART_EMPTY: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="20" height="20"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>`,
  HEART_FILLED: `<svg viewBox="0 0 24 24" fill="#D42135" stroke="#D42135" stroke-width="1.5" width="20" height="20"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>`,

  // Injecter les cœurs sur les cards du scroll produits
  initCards() {
    document.querySelectorAll('.rcs-card').forEach(card => {
      if (card.querySelector('.rc-heart-btn')) return;
      const url = card.getAttribute('href') || '';
      const name = card.querySelector('.rcs-card__name')?.textContent || '';
      const price = card.querySelector('.rcs-card__price')?.textContent || '';
      const img = card.querySelector('img')?.src || '';
      const id = url.split('/').pop() || name;

      const btn = this.renderButton(id, { id, name, price, img, url });
      btn.style.position = 'absolute';
      btn.style.top = '10px';
      btn.style.right = '10px';
      card.style.position = 'relative';
      card.querySelector('.rcs-card__img')?.appendChild(btn);
    });
  },

  // Injecter le cœur sur la page produit
  initProductPage() {
    const form = document.querySelector('product-form form, form[action="/cart/add"]');
    if (!form) return;

    const productId = document.querySelector('[data-product-id]')?.dataset.productId
      || window.location.pathname.split('/').pop();
    const name = document.querySelector('.product__title')?.textContent?.trim() || '';
    const price = document.querySelector('.price__regular .price-item, .price-item--regular')?.textContent?.trim() || '';
    const img = document.querySelector('.product__media img')?.src || '';
    const url = window.location.pathname;

    const productData = { id: productId, name, price, img, url };

    // Si un coeur inline existe (rendu par buy-buttons.liquid), brancher son clic
    const inlineHeart = document.querySelector('.rc-heart-inline');
    if (inlineHeart) {
      inlineHeart.classList.add('rc-heart-product-btn');
      inlineHeart.classList.toggle('rc-heart-btn--active', this.has(productId));
      inlineHeart.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const added = this.toggle(productId, productData);
        inlineHeart.classList.toggle('rc-heart-btn--active', added);
        inlineHeart.style.transform = 'scale(1.3)';
        setTimeout(() => inlineHeart.style.transform = '', 200);
      });
      return;
    }
    // Fallback : injection dynamique si pas de coeur inline
    const existing = document.querySelector('.rc-heart-product-btn');
    if (!existing) {
      const heartBtn = this.renderButton(productId, productData);
      heartBtn.className += ' rc-heart-product-btn';
      const atcBtn = document.querySelector('button[name="add"], .product-form__submit');
      if (atcBtn) {
        const atcRow = atcBtn.closest('.product-form__quantity-and-btn');
        if (atcRow) atcRow.appendChild(heartBtn);
        else atcBtn.insertAdjacentElement('afterend', heartBtn);
      }
    }
  },

  // Initialisation globale
  init() {
    this.updateCounters();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.initCards();
        if (window.location.pathname.includes('/products/')) this.initProductPage();
      });
    } else {
      this.initCards();
      if (window.location.pathname.includes('/products/')) this.initProductPage();
    }

    // Observer pour les contenus dynamiques
    new MutationObserver(() => this.initCards()).observe(document.body, { childList: true, subtree: true });
  }
};

RCWishlist.init();
window.RCWishlist = RCWishlist;
